import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { Settings } from "./settings";

export const userManager = new UserManager({
    authority: Settings.getBackendBaseUrl() + '/api/v1/',
    client_id: Settings.getClientId(),
    redirect_uri: Settings.getRedirectUri(),
    post_logout_redirect_uri: Settings.getPostLogoutRedirectUri(),
    response_type: 'code',
    scope: 'openid',
    refreshTokenAllowedScope: '',
    automaticSilentRenew: true,
    loadUserInfo: true,
    userStore: new WebStorageStateStore({
        prefix: Settings.getStorageKeyPrefixOidc(),
        store: window.sessionStorage
    }),
});

export const signInWhenTokenExpires = () => {
    userManager.getUser().then(user => {
        if (user && user.expired) {
            userManager.signinSilent().catch(err => {
                console.error('Error during silent sign-in:', err);
            });
        }
    });
}
